import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  BASE_BUY_URL,
  BASE_CHART_URL,
  BASE_DCKS_CONTRACT_URL,
} from '../../../config/siteContent';
import {
  getRoundedTreasuryTotalValueUSD,
} from '../TreasuryPage/treasuryValue';
import './Footer.scss';

const DEFAULT_ROUNDED_TREASURY_VALUE = 500000;

const FOOTER_EXTERNAL_LINKS = [
  { label: 'Uniswap', href: BASE_BUY_URL },
  { label: 'Dexscreener', href: BASE_CHART_URL },
  { label: 'BaseScan', href: BASE_DCKS_CONTRACT_URL },
  { label: 'X', href: 'https://x.com/REDDICKS_XRD' },
  { label: 'Telegram', href: 'https://t.me/RedDicks_XRD' },
];

const Footer = () => {
  const [roundedTreasuryValue, setRoundedTreasuryValue] = useState(DEFAULT_ROUNDED_TREASURY_VALUE);

  useEffect(() => {
    let isMounted = true;

    const loadTreasuryValue = async () => {
      try {
        const roundedValue = await getRoundedTreasuryTotalValueUSD();

        if (isMounted && roundedValue > 0) {
          setRoundedTreasuryValue(roundedValue);
        }
      } catch (error) {
        console.warn('Failed to refresh footer treasury value:', error);
      }
    };

    loadTreasuryValue();

    return () => {
      isMounted = false;
    };
  }, []);

  const treasuryValueLabel = `$${roundedTreasuryValue.toLocaleString()}`;

  return (
    <footer className="home-footer">
      <div className="footer-bg-glow" aria-hidden="true"></div>
      <div className="footer-content">
        <div className="footer-top">
          <div className="footer-brand-block">
            <p className="footer-tagline">The hardest memecoin on Radix + Base</p>
            <span className="footer-seal">Certified on-chain chaos</span>
            <a
              href="mailto:SatoshiGBOF@gmail.com"
              className="footer-email"
            >
              ✉ SatoshiGBOF@gmail.com
            </a>
          </div>

          <div className="footer-grid">
            <div className="footer-col">
              <h4>Get In</h4>
              <Link to="/buy">Buy</Link>
              <Link to="/stake">Stake</Link>
              <Link to="/validator">Validator</Link>
            </div>
            <div className="footer-col">
              <h4>Research</h4>
              <Link to="/home">Home</Link>
              <Link to="/tokenomics">Tokenomics</Link>
              <Link to="/verify">Verify Liquidity</Link>
              <Link to="/treasury">Treasury</Link>
              <Link to="/charity">Charity</Link>
            </div>
            <div className="footer-col">
              <h4>Fun</h4>
              <Link to="/game-info">Reddicks Games</Link>
              <Link to="/image-creator">AI Meme Creator</Link>
              <Link to="/memecollection">Meme Collection</Link>
              <Link to="/dckslap">DCKSlap</Link>
            </div>
          </div>
        </div>

        <div className="footer-links" aria-label="External links">
          {FOOTER_EXTERNAL_LINKS.map((link, index) => (
            <React.Fragment key={link.label}>
              {index > 0 && <span className="footer-link-separator" aria-hidden="true">|</span>}
              <a
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                className="footer-link"
              >
                {link.label}
              </a>
            </React.Fragment>
          ))}
        </div>

        <div className="footer-disclaimer">
          <p>
            <strong>REDDICKS</strong> is a community-driven meme token deployed on
            <span> Radix</span>, <span>Base</span>, and soon <span>Solana</span>.
          </p>
          <p>
            <strong>REDDICKS Treasury</strong> holds roughly {treasuryValueLabel} in protocol-owned
            assets supporting the ecosystem. Nothing on this website constitutes
            financial advice.
          </p>
        </div>

        <div className="copyright">
          <p>&copy; 2026 Reddicks. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
